/* Meno Aliv PDP — animação dos acordeões (<details>) do kit, composição e dúvidas.
   Sem JS o <details name> nativo já abre/fecha e mantém um aberto por grupo;
   aqui a altura passa a animar. O `name` vira data-acc-group porque, com ele,
   o browser fecharia o vizinho seco, antes da animação de fechar. */
(function () {
  "use strict";

  var SEL = ".pdp-kit__item, .pdp-acc";
  var EASE = "cubic-bezier(0.22, 1, 0.36, 1)";
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");

  // Anima a altura do <details> inteiro (não do corpo), assim o padding do
  // corpo não "sobra" no fechamento.
  function animate(d, open) {
    if (d._anim) d._anim.cancel();
    if (reduced.matches) { d.open = open; return; }
    var start = d.offsetHeight;
    if (open) d.open = true;
    var borders = d.offsetHeight - d.clientHeight;
    var end = open ? d.offsetHeight : d.querySelector("summary").offsetHeight + borders;
    d.style.overflow = "hidden";
    d._anim = d.animate({ height: [start + "px", end + "px"] }, { duration: 300, easing: EASE });
    d._anim.onfinish = function () {
      d._anim = null;
      d.style.overflow = "";
      if (!open) d.open = false;
    };
  }

  function onClick(e) {
    var summary = e.target.closest("summary");
    var d = summary && summary.parentElement;
    if (!d || !d.matches(SEL)) return;
    e.preventDefault();
    var opening = !d.open;
    var group = d.getAttribute("data-acc-group");
    if (opening && group) {
      document.querySelectorAll('[data-acc-group="' + group + '"][open]').forEach(function (o) {
        if (o !== d) animate(o, false);
      });
    }
    animate(d, opening);
  }

  function adopt(root) {
    (root || document).querySelectorAll(SEL).forEach(function (d) {
      var name = d.getAttribute("name");
      if (!name) return;
      d.setAttribute("data-acc-group", name);
      d.removeAttribute("name");
    });
  }

  document.addEventListener("click", onClick);
  if (document.readyState !== "loading") adopt(document);
  else document.addEventListener("DOMContentLoaded", function () { adopt(document); });
  document.addEventListener("shopify:section:load", function (e) { adopt(e.target); });
})();
